import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Barn } from '../../models/barn.model';
import { SettingModuleState } from '../../models/setting.model';
import * as settingActions from '../actions/setting.actions';

function selectIdNumber(b: Barn): number {
  return b.id;
}

function sortByName(a: Barn, b: Barn): number {
  return a.name.localeCompare(b.name);
}

export const adapter: EntityAdapter<Barn> = createEntityAdapter({
  selectId: selectIdNumber,
  sortComparer: sortByName,
});

export const initialState = <SettingModuleState>{
  barns: adapter.getInitialState([]),
  selectedBarn: <Barn>{},
  isLoaded: false,
};

const settingReducer = createReducer(
  initialState,
  on(settingActions.loadBarnsSuccess, (state, { barns }) => ({
    ...state,
    selectedBarn: <Barn>{},
    barns: adapter.setAll(barns, state.barns),
    isLoaded: true,
  })),
  on(settingActions.upsertBarnSuccess, (state, { barn }) => ({
    ...state,
    selectedBarn: barn,
    barns: adapter.upsertOne(barn, state.barns),
  })),
  on(settingActions.deleteBarnSuccess, (state, { barn }) => ({
    ...state,
    selectedBarn: <Barn>{},
    barns: adapter.removeOne(barn.id, state.barns),
  })),
  on(settingActions.upsertBarn, (state, { barn }) => ({
    ...state,
    selectedBarn: barn,
  })),
  on(settingActions.setSelectedBarn, (state, { barnId }) => ({
    ...state,
    selectedBarn:
      !!barnId && !!state.barns.entities[barnId] ? state.barns.entities[barnId] : <Barn>{},
  })),
);

export function reducer(state: SettingModuleState | undefined, action: Action) {
  return settingReducer(state, action);
}
